import { cn } from '@commenda/utils';
import { Fragment } from 'react';
import { DataPoint, TDataPointAction } from '../Corporation/common/DataPoint';

const ROW_SEPARATOR_CLASS_NAMES = 'mx-xl h-px bg-border-primary';

export type TGridViewAction = TDataPointAction;

export type TGridViewDataPoint = {
  heading: string;
  value: string | React.ReactNode;
  isHidden?: boolean;
  onCopy?: () => void;
  actions?: TGridViewAction[];
};

export const GridView = ({
  dataPoints,
  title,
  description,
  disableRowClick = false,
}: {
  dataPoints: TGridViewDataPoint[];
  title?: string;
  description?: string;
  disableRowClick?: boolean;
}) => {
  const filteredDataPoints = dataPoints.filter(
    (dataPoint) => !dataPoint.isHidden
  );

  return (
    <div className="flex flex-col border border-border-primary rounded-xl bg-bg-primary overflow-clip">
      {(title || description) && (
        <div className="flex flex-col gap-xxs px-xl pt-xl pb-lg">
          {title && (
            <h4 className="txt-medium-bold text-text-primary">{title}</h4>
          )}
          {description && (
            <p className="txt-small-regular text-text-tertiary">
              {description}
            </p>
          )}
        </div>
      )}
      {filteredDataPoints.map((dataPoint, index) => (
        <Fragment key={dataPoint.heading || index}>
          {(index > 0 || title || description) && (
            <div className={ROW_SEPARATOR_CLASS_NAMES} />
          )}
          <DataPoint
            title={dataPoint.heading}
            value={dataPoint.value}
            onCopy={dataPoint.onCopy}
            actions={dataPoint.actions}
            hideAddAction
            className={cn(
              !disableRowClick && 'hover:bg-bg-secondary cursor-pointer'
            )}
          />
        </Fragment>
      ))}
    </div>
  );
};
